import { Calendar as ANTDCalendar, CalendarProps } from 'antd';
import { Dayjs } from 'dayjs';

export type { CalendarMode, CalendarProps } from 'antd';

const locale = {
  lang: {
    locale: 'en_US',
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date'] as [string, string],
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    month: 'Month',
    year: 'Year',
    timeSelect: 'Select time',
    dateSelect: 'Select date',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    yearFormat: 'YYYY',
    fieldDateFormat: 'DD-MM-YYYY',
    cellDateFormat: 'D',
    fieldDateTimeFormat: 'DD-MM-YYYY, HH:mm',
    monthFormat: 'MMMM',
    fieldWeekFormat: 'YYYY-wo',
    week: '',
    monthBeforeYear: true,
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century',
    shortWeekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    shortMonths: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
  },
  timePickerLocale: { placeholder: 'Select time' },
};

export const Calendar = (props: CalendarProps<Dayjs>) => {
  return <ANTDCalendar {...props} locale={locale} />;
};
